import React, { useContext, useEffect, useState } from "react";
// import { decrypt } from "../utils/encryption";
import { IAuthState, IUser } from "../types/user";
import { getClient } from "../utils/http";

const userEmptyState = {
  userId: "",
  name: "",
  username: "",
  accessToken: "",
  scopes: [],
};

const AuthContext = React.createContext<IAuthState | null>(null);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

const getUser = () => {
  const userDetails = localStorage.getItem("userDetails");
  if (userDetails) {
    // return JSON.parse(decrypt(userDetails));
    return JSON.parse(userDetails);
  } else {
    return userEmptyState;
  }
};

const getSource = () => {
  const source = localStorage.getItem("source");
  if (source) {
    return source;
  } else {
    return "";
  }
};

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [userDetails, setUserDetails] = useState<IUser>(getUser());
  const [source, setSource] = useState<string>(getSource());
  const [logoutLoader, setIsLogoutLoader] = useState<boolean>(false);
  const [encKey, setEncKey] = useState<string>("");

  const handleLogout = async () => {
    try {
      setIsLogoutLoader(true);
      await getClient("document").post("/delete-file");
      setUserDetails(userEmptyState);
      localStorage.removeItem("userDetails");
      localStorage.removeItem("publicKey");
      setIsLogoutLoader(false);
      window.history.pushState("", "", "/login");
    } catch (error) {
      setIsLogoutLoader(false);
      console.log(error);
    }
  };

  const getKey = async () => {
    try {
      const { data } = await getClient().get("/cxo-dashboard/auth/public-key");
      localStorage.setItem("publicKey", data?.publicKey);
      setEncKey(data?.publicKey);
    } catch (error) {
      console.error("Error fetching encryption key:", error);
    }
  };

  useEffect(() => {
    if (!encKey) {
      getKey();
    }
  }, [encKey]);

  return (
    <AuthContext.Provider
      value={{
        userDetails,
        setUserDetails,
        handleLogout,
        source,
        setSource,
        logoutLoader,
        encKey,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
